import React from "react";
import "../css/featured.css";
import Navbar from "../Navbar";
import ExploreMore from "../ExploreMore";

export const Women4 = () => {
  return (
    <>
      <Navbar />
      <div className="featured-con">
        <div className="layout">
          <h1 className="article-title">
            The Artist Turned HR Leader: Esi Mmirba Wilson's Blueprint for HR
            Excellence
          </h1>
          <div className="article-category">
            Africa's 10 Most Influential Women Leaders to Watch in 2024
          </div>
          <div className="share-container">
            <div className="share-buttons">
              <button className="share-button linkedin">LinkedIn</button>
              <button className="share-button twitter">Twitter</button>
              <button className="share-button facebook">Facebook</button>
            </div>
          </div>
          <div className="article-image-container">
            <img
              src="./images/Norah-Galea.jpg"
              alt="Professional woman at desk"
              className="article-image"
            />
            <div className="article-image-caption">
              Norah Galea | Owner and Creator | Knock Thrice Inc
            </div>
          </div>
          {/* Article Content */}
          <div className="article-content">
            <p>
              Norah Galea is the Owner and Creator of Knock Thrice Inc., an
              independent brand and online storefront offering unique apparel,
              accessories, and other whimsical wares. What began as a pandemic
              pastime in hand embroidery blossomed into a full-time business
              during her final year at art school. Today, Knock Thrice features
              a diverse range of “wearable art,” including purses, cardigans,
              and mugs, each piece carefully designed by Norah and her small
              team. The company specializes in high quality, lovingly crafted
              garments in sizes for all folks in all bodies. I knew I wanted to
              be an entrepreneur when… I decided to make art my living. I wanted
              to live alongside my creative work, keeping my life full of colour
              and creation. I quickly realized that I had to create that space
              myself, outside traditional employment structures. It is hard
              work, but there was no alternative. Entrepreneurship is made for
              me because… rather than accepting problems I am faced with, I am
              immediately spurred to take them on headfirst. Knock Thrice is an
              expression of my own personality, dreams and desires, and I make
              the sort of clothing that I would want to wear. The impact I hope
              to make through my work is… inspiring and encouraging people to
              be, look, feel, and dress in a way that is authentic to them. To
              welcome beautiful things into their daily lives, to look at the
              mundane with a closer eye and see the beauty of the everyday. To
              appreciate the textures, the colours, the sights we might overlook
              when we become too busy or stressed. One of the most important
              lessons I’ve learned on my entrepreneurial journey is… to follow
              any whim and wander slowly down a curious path to see where it
              leaves you. Inspiration looks different for everyone, as does
              growth and success. Be on your own time, and take as much of it as
              you need. Your business — and subsequently your life — will
              reflect your priorities, so make them connection, authenticity,
              fun, creativity, and quality. My proudest accomplishment is…
              getting messages from artists telling me that my work inspires,
              comforts, or makes them feel seen. I am thankful to my fellow
              creators who shared their work and brought beauty to my life. I am
              now equally thankful to know those who let me know I’ve done the
              same. The biggest risk I took that paid off was… pivoting rather
              quickly from an entirely hand-embroidered, one-of-a-kind business
              model, to an incorporated company, working with manufacturers and
              designers all over the world. I feared that my customers,
              followers, and even I would be disappointed and miss the magic of
              my hand embroidered items. But demand was outstripping my ability
              to supply, and so I decided to scale the company up. Thankfully,
              it’s allowed me to share my work globally, to work with incredible
              artists, to make amazing friends, and to dedicate the correct time
              to each project, rather than rushing to the next thing. My biggest
              setback has been… working alone. Managing everything from social
              media and website design, to content creation, concept design,
              product development, and even filing taxes, I was drowning. I had
              never dealt with any of this before, and it took a major toll on
              my mental health. Not to mention my physical health — as I
              embroidered nonstop, a wrist injury developed incredibly fast and
              I could no longer do my work. I overcame it by… taking a real
              break, for the first time in two years. I rested physically,
              mentally, and had to decide whether to stop or change Knock
              Thrice. I decided to change my role and introduce manufactured
              products into my shop, gradually phasing out my hand-embroidered
              items. Thankfully, my followers and audience grew, with the
              newcomers excited about these new products. I feared this dramatic
              change at first, but now realize that the artist in me remains —
              she’s just made a little room for the entrepreneur. The best
              advice I’ve received as an entrepreneur was… “Fake it till you
              make it.” Nobody is born knowing how to start a business. Nearly
              everybody has Googled their problem or phoned a friend to figure
              out some part of the system. Let the knowledge that there is no
              right answer comfort you rather than scare you. I surprise people
              when I tell them… I studied film and media in art school. People
              believe that you require a business degree or a certificate to
              launch into the world of entrepreneurship. Business acumen,
              marketing, and statistics analysis are skills that can be learned.
              Thinking creatively, wandering from the well-trodden path into
              unexplored territory, trying and failing and trying again are
              traits which everyone has, but not everyone acts upon. Artists do
              this from day one, so the first failure doesn’t sting as badly.
              After all, it’s just a first draft. If I had an extra hour in the
              day, I would use it to… play fiddle more and learn to make bread.
              Now that my wrists have recovered from ten hours of embroidery a
              day, I would use my extra time to develop my other hobbies, like
              music. If you googled me, you still wouldn’t know… I collect decks
              of playing cards and have five or six pen pals. I like
              memorabilia, paper media, letters, and games. The future excites
              me because… it’s so full of possibilities. I’ve given up trying to
              control it so stringently. After the pandemic, it has become clear
              that the much-touted “ten-year plan” is just that, a plan — and a
              plan can be scrapped and redesigned from scratch if need be. My
              plans for the future are more flexible and abstract, including
              taking oil painting classes, rereading my favourite books,
              knitting a blanket, and seeing Japan. As the creator, designer,
              and conceptualizer for my brand, it’s my artistic responsibility
              to keep my life interesting — I owe it to my company, and to
              myself.
            </p>
          </div>
        </div>
      </div>
      <ExploreMore/>
    </>
  );
};
